import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { Badge } from '@capawesome/capacitor-badge';
import { Capacitor } from '@capacitor/core';
import { AppService, UserService, DatabaseService } from '.';

export interface ICounter {
  unreadConversations?: number;
  unreadAppointments?: number;
  unreadActivity?: number;
  incompleteForms?: number;
}

@Injectable({
  providedIn: 'root'
})
export class CounterService {

  public counters: ICounter = {};
  public counterObject: Observable<ICounter>;
  public counterSubscription: Subscription;
  public countersSubject = new Subject<ICounter>();

  constructor(
    private appService: AppService,
    private dbService: DatabaseService,
    private userService: UserService,
  ) { }

  public getUserCountersSubscription(userId) {
    return this.dbService.getObjectByRef(`userCounters/${userId}`, "id")
  }

  public async setCounter(counterName: string, value: number): Promise<void> {
    this.counters[counterName] = value;
    if(Capacitor.isNativePlatform()) {
      try {
        await Badge.set({ count: this.getCounterTotal() });
      } catch (error) {
        console.error('Error setting badge number:', error);
      }
    }
    this.saveUserCounters();
    this.publishCounterStateSubject();
  }

  public saveUserCounters() {
    if(this.userService.getAppUser()?.uid) {
      this.dbService.setRef(`users/${this.userService.getAppUser().uid}/notificationCount`, this.getCounterTotal()).then(() => {}).catch(() => {})
    }
  }

  private publishCounterStateSubject() {
    this.countersSubject.next(this.counters);
  }

  private getCounterTotal(): number {
    let toReturn = 0;
    if(!this.counters || Object.keys(this.counters).length === 0) {
      return toReturn
    } else {
      const values = Object.values(this.counters);
      for(const value of values) {
        if(isNaN(value)) {
          continue
        } else {
          toReturn += value;
        }
      }
      return toReturn
    }
  }

  public getCountersSubject(): Subject<ICounter> {
    return this.countersSubject;
  }

  public async clearCounters() {
    this.counters = {};
    this.counterObject = null;
    if(this.counterSubscription) {
      this.counterSubscription.unsubscribe();
    }
    if(Capacitor.isNativePlatform()) {
      try {
        await Badge.set({ count: 0 });
      } catch (error) {
        console.error('Error clearing badge number:', error);
      }
    }
  }
}
